const TEMPLATE_TOKEN_PATTERN = '\\{\\{[^{}]+\\}\\}';

export const getTemplateTokenRegex = (): RegExp => new RegExp(TEMPLATE_TOKEN_PATTERN, 'g');

export const containsTemplateToken = (text: string): boolean => new RegExp(TEMPLATE_TOKEN_PATTERN).test(text);

export const findTemplateTokens = (text: string): string[] => text.match(getTemplateTokenRegex()) ?? [];
